export default __webpack_public_path__ + "static/media/movieSeatBooking.81a03226.gif";